import type { Menu, Reference } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSMenu, useCMSReference } from '@swf/cms';
import Arrow from '@swf/core/assets/icons/arrow.svg';
import useTouchSupported from '@swf/core/hooks/useTouchSupported';

import styles from './CMSNavigationItem.scss';

interface Props {
  reference: Reference;
  maxDepth: number;
  isSeoMenu?: boolean;
  menuOpen?: boolean;
  activeItem?: string;
  tagItem?: string;
  onClick?(): void;
}

const CMSNavigationItem: React.FC<Props> = ({
  reference,
  maxDepth,
  isSeoMenu = false,
  menuOpen = false,
  activeItem = '',
  tagItem = '',
  onClick
}) => {
  const menu = useCMSReference<Menu>(reference) as Menu;
  const isTouchSupported = useTouchSupported();

  return menu ? (
    <div className={isSeoMenu ? styles.seoMenu : ''}>
      <CMSMenu
        menu={menu}
        depth={0}
        maxDepth={1}
        onClick={onClick}
        internalItem={styles.navItem}
        activeItem={!isSeoMenu ? classNames(styles.navItemActive, activeItem) : ''}
        tagName={isTouchSupported && maxDepth > 1 && !!menu.children.length ? 'span' : undefined}
        tagItem={tagItem}
      />
      {!!menu.children.length && isSeoMenu && (
        <Arrow className={classNames(styles.arrow, { [styles.closed]: !menuOpen })} />
      )}
    </div>
  ) : null;
};

export default CMSNavigationItem;
